import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { curry, get, isUndefined, omit } from 'lodash';

import { findByPropPathValue } from '../utils';
import { RequestLineFieldsFragment } from '../constants';
import { NAME as REQUEST_LINES_QUERY } from '../withCaseRequestLines';
import { CASE_REQUEST_ASSETS_QUERY_NAME } from '../../RequestAssetsForm/withRequestAssets/caseRequestAssetsQuery';

const NAME = 'compositions_CaseRequestPanel_CaseUpdateAgreementLine';

const mutation = gql`
  mutation ${NAME} ($id: ID!, $patch: CaseAgreementLinePatch) {
    updateCaseAgreementLine(input: {id: $id, patch: $patch }) {
      requestAgreementLine {
        agreed
        agreementLine { ...RequestLineFields }
      }
    }
  }
  ${RequestLineFieldsFragment}
`;

const buildMutationChild = curry((WrappedComponent, componentProps, mutate) => {
  const updateRequestAgreementLine = variables => {
    const { agreed, agreementLine } = findByPropPathValue(
      get(componentProps, 'requestAgreementLines', []),
      'agreementLine.id',
      variables.id,
    );

    mutate({
      variables: {
        ...variables,
        patch: {
          ...variables.patch,
          agreementLine: {
            ...omit(get(variables, 'patch.agreementLine'), 'asset'),
            assetId: get(variables, 'patch.agreementLine.asset.id'),
          },
        },
      },
      optimisticResponse: {
        updateCaseAgreementLine: {
          __typename: 'CaseAgreementLinePayload',
          requestAgreementLine: {
            __typename: 'CaseAgreementLine',
            agreed: isUndefined(variables.patch.agreed)
              ? agreed
              : variables.patch.agreed,
            agreementLine: {
              __typename: 'CaseRequestLine',
              ...agreementLine,
              ...variables.patch.agreementLine,
            },
          },
        },
      },
    });
  };

  return (
    <WrappedComponent
      {...componentProps}
      updateRequestAgreementLine={updateRequestAgreementLine}
    />
  );
});

const withCaseUpdateRequestAgreementLine = WrappedComponent => componentProps => (
  <Mutation
    mutation={mutation}
    refetchQueries={[REQUEST_LINES_QUERY, CASE_REQUEST_ASSETS_QUERY_NAME]}
  >
    {buildMutationChild(WrappedComponent, componentProps)}
  </Mutation>
);

export default withCaseUpdateRequestAgreementLine;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestAgreementLinesActions/withUpdateCaseAgreementLine.js